import type { CmpHider } from './types';

export const securiti: CmpHider = {
  id: 'securiti',
  label: 'Securiti',
  css: `
      /* Securiti (securiti.ai CMP): Securiti's consent UI is built on the
         Insites "cookieconsent" library, so the visible banner is a single
         fixed container ".cc-window" (rendered as ".cc-banner" for the bottom
         bar and ".cc-floating" for the floating card, z-index 9999) appended
         directly to <body>; it holds the ".cc-message" text and the
         "#securitiCmpCookiePrefBtn" / ".cmp-pref-link" preferences link. Hiding
         ".cc-window" removes the whole banner in one go. We also hide Securiti's
         fixed ".cmp-loader" spinner and the "#securitiCmpCookiePrefBtn" link
         defensively in case a build renders them outside the window. Securiti
         does not dim the page with a separate fixed backdrop, and it does not
         lock page scroll via a body class or inline style on the sites observed;
         if a build does, the html/html-body[style*="overflow"] release rule
         above (added for Cookiebot) already out-specifies an inline overflow
         lock. */
      .cc-window,
      .cc-banner,
      .cc-floating,
      .cmp-loader,
      #securitiCmpCookiePrefBtn { display: none !important; }
  `,
};
